/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from 'react';
import { createContainer } from 'unstated-next';
import { TrackingConsents } from '../components/ConsentMode/ConsentMode';
import { generateUUID } from '../components/utils';

export interface Meta {
	searchServer: string | undefined;
	setSearchServer(server: string | undefined): void;
	trackingConsents: TrackingConsents;
	setTrackingConsents(consents: TrackingConsents): void;
	searchEngine: SearchEngine | undefined;
	setSearchEngine(engine: SearchEngine): void;
	searchProfileId: string;
	setSearchProfileId(id: string): void;
	randomizeSearchProfileId: boolean;
	setRandomizeSearchProfileId(randomize: boolean): void;
	cookiebotLoaded: boolean;
	setCookiebotLoaded(loaded: boolean): void;
}

export type SearchEngine = 'loop' | 'solr' | 'not-set';

function buildMeta(): Meta {
	let [searchServer, setSearchServer] = useState<string | undefined>(undefined);
	let [searchEngine, setSearchEngine] = useState<SearchEngine>();
	let [searchProfileId, setSearchProfileId] = useState(generateUUID());
	let [randomizeSearchProfileId, setRandomizeSearchProfileId] = useState(true);
	let [cookiebotLoaded, setCookiebotLoaded] = useState(false);
	const [trackingConsents, setTrackingConsents] = useState<TrackingConsents>({
		marketing: false,
		necessary: false,
		preferences: false,
		statistics: false,
	});

	return {
		searchServer,
		setSearchServer(server) {
			if (server && searchServer !== server) setSearchServer(server);
		},
		trackingConsents,
		setTrackingConsents(consents) {
			setTrackingConsents(consents);
		},
		searchEngine,
		setSearchEngine,
		searchProfileId,
		setSearchProfileId,
		randomizeSearchProfileId,
		setRandomizeSearchProfileId,
		cookiebotLoaded,
		setCookiebotLoaded,
	};
}

export const MetaContainer = createContainer(buildMeta);
